import axios from "axios";
import { isDemoMode, demoResolve } from "./demoStore";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Demo mode short-circuit — serve responses from the client-side fixture
// instead of hitting the backend. Runs before the request is dispatched.
api.interceptors.request.use((cfg) => {
    const t = localStorage.getItem("afo_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    if (isDemoMode()) {
        const url = (cfg.url || "").replace(/^\/api/, "");
        // Try to parse the request body (axios stringifies to JSON by default)
        let body = cfg.data;
        if (typeof body === "string") { try { body = JSON.parse(body); } catch { /* ignore */ } }
        const resolved = demoResolve(cfg.method || "GET", url, body);
        if (resolved) {
            // Short-circuit: throw an object that the response interceptor
            // recognises as a fake success, then convert it back to a
            // resolved axios response.
            const err = new Error("demo-short-circuit");
            err.__demoResponse = { data: resolved.data, status: 200,
                                    statusText: "OK (demo)", headers: {},
                                    config: cfg };
            throw err;
        }
    }
    return cfg;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err && err.__demoResponse) return Promise.resolve(err.__demoResponse);
        return Promise.reject(err);
    }
);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const AUD = (n) => {
    if (n == null || isNaN(n)) return "—";
    return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
        maximumFractionDigits: 0,
    }).format(n);
};

export const AUDc = (n) => {
    if (n == null || isNaN(n)) return "—";
    return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
        maximumFractionDigits: 2,
    }).format(n);
};

export const PCT = (n, digits = 1) => {
    if (n == null || isNaN(n)) return "—";
    return `${(n * 100).toFixed(digits)}%`;
};
